import FolderTree from './FolderTree';

export default FolderTree;
